__turbopack_context__.v({
  "attribute-grid-container": "ZWH8-q_attribute-grid-container",
  "attribute-grid-desktop": "ZWH8-q_attribute-grid-desktop",
  "attributes-title-heading": "ZWH8-q_attributes-title-heading",
  "design-attribute-container": "ZWH8-q_design-attribute-container",
  "design-attribute-content": "ZWH8-q_design-attribute-content",
  "design-attribute-description": "ZWH8-q_design-attribute-description",
  "design-attribute-title": "ZWH8-q_design-attribute-title",
});
